import http from '@/assets/js/http';
// 获取服务项目
export const getServer = function() {
  return http.get('/v1/app/Server');
}

// 获取用户上次下单填写的信息
export const getOrderHistory = () => http.get('/v1/app/OrderHistory');

// 服务下单
export const placeOrder = (data) => http.post('/v1/app/Order', data);

// 获取订单列表
export const getOrderList = (data) => http.get('/v1/app/Order', data);

//删除订单
export const delOrders = (uuid) =>  http.delete(`/v1/app/Order/${uuid}`);

// 获取快捷标签
export const getQuickTag = (data) => http.get('/v1/app/QuickTag', data);

// 订单详情
export const getOrderDetail = (data) => http.get(`/v1/app/Order/${data}`);

// 确认支付
export const getOrderPay = (data) => http.post('/v1/app/OrderPay', data);

// 取消/确认/驳回/催单/退款/撤销退款
export const operateOrder = (data, obj) => http.put(`/v1/app/Order/${data}`, obj);

// 跟进订单
export const getOrderFollow = (data, obj) => http.get(`/v1/app/OrderFollowRecord/${data}`, obj);

// 评价订单
export const getOrderComment = (data) => http.post('/v1/app/OrderComment', data);

// 追加金额下单
export const getOrderAdd = (data) => http.post('/v1/app/OrderAdd', data);

// 追加金额支付
export const getOrderAddPay = (data) => http.post('/v1/app/OrderAddPay', data);

// 追加金额订单支付状态
export const getAddPayStatus = (data) => http.get(`/v1/app/OrderAdd/${data}`);

// 获取默认佣金
export const getCommission = () => http.get('/v1/app/CommissionSetting');

// 获取用户常用旺旺
export const getUserWangWang = () => http.get('/v1/app/UserWangWang');

// 获取用户退款记录
export const getOrderRefundRecord = (data) => http.get('/v1/app/OrderRefundRecord', data);

// 订单补充信息
export const addSupplement = (data) => http.post('/v1/app/Order/addSupplement', data);

// 业务员新增更近记录
export const addFollowRecord = (data, obj) => http.put(`/v1/app/OrderFollowRecord/${data}`, obj);



